export const extractFileNameFromFullPath = path => path?.split?.('/')
    ?.pop
    ?.() ?? '';
